/*eslint no-undef: */
// import Vue from 'vue';
// import Vuetify from 'vuetify/lib';
// import colors from 'vuetify/lib/util/colors';
import i18n from './i18n';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  // theme: {
  //   themes: {
  //     light: {
  //       primary: '#EC196A'
  //     },
  //     dark: {
  //       primary: colors.orange.base
  //     },
  //   },
  // }

  // ------ this can be work
  // theme: {
  //   themes: {
  //     light: {
  //       primary: colors.brown.base
  //     },
  //     dark: {
  //       primary: colors.orange.base
  //     },
  //   },
  // }


  // ------ this is not work...
  // default: {
  //   props: { color: 'primary' }
  // }
});
